var _rule = require("../rule.js");

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _rule2.default.makeRule({
    name: "math-nested",
    severity: _rule2.default.Severity.ERROR,
    selector: "math, blockMath",
    pattern: /\\text{[^$}]*\$[^$}]*\$[^}]*}/,
    message: "Nested math:\nDon't nest math expressions inside \\text{} blocks"
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/gorgon/rules/math-nested.js
 ** module id = 228
 ** module chunks = 0 2
 **/